import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    calculationId: String,
  };

  static targets = [
    "nextButton",
    "facilitySelect",
    "yearSelect",
    "newFacilityPanel",
    "calcExistsMessage",
    "checkbox1",
    "checkbox2",
    "checklistSection",
    "checklistPanel",
    "warningPanel",
    "checklistWarning",
    "testCheckbox",
  ];

  connect() {
    // Initial validation check for any step
    this.validateForm();
  }

  openNewFacilityPanel() {
    const locale = document.documentElement.lang;
    const url = `/${locale}/facilities/wizard/new?sidepanel=true`;

    const frame = document.getElementById("new-facility-frame");
    if (frame) {
      frame.src = url;
    }
    this.newFacilityPanelTarget.style.right = "0";
    this.newFacilityPanelTarget.classList.add("panel-open");
    const backgroundOverlay = document.getElementById("background-overlay");
    backgroundOverlay.classList.add("visible");
  }

  closeNewFacilityPanel() {
    this.newFacilityPanelTarget.style.right = "-100%";
    this.newFacilityPanelTarget.classList.remove("panel-open");
    this.newFacilityPanelTarget.style.left = "100%";
    const backgroundOverlay = document.getElementById("background-overlay");
    backgroundOverlay.classList.remove("visible");
  }

  chooseFacility(event) {
    event.preventDefault();

    const facilityId = event.currentTarget.dataset.facilityId;
    if (!facilityId) return;

    this.facilitySelectTarget.value = facilityId;
    this.facilitySelectTarget.dispatchEvent(new Event("change"));
    this.validateForm();
  }

  chooseYear(event) {
    event.preventDefault();
    const year = event.currentTarget.dataset.year;
    if (!year) return;

    this.yearSelectTarget.value = year;
    this.yearSelectTarget.dispatchEvent(new Event("change"));
    this.validateForm();
  }

  facilityChanged() {
    this.validateForm();
  }

  yearChanged() {
    this.validateForm();
  }

  testChanged() {
    this.validateForm();
  }

  validateChecks() {
    const checkboxes = [this.checkbox1Target, this.checkbox2Target];

    const allChecked = checkboxes.every((cb) => cb.checked);

    this.warningPanelTarget.hidden = allChecked;

    if (allChecked) {
      this.checklistPanelTarget.style.borderRadius = "12px";
    } else {
      this.checklistPanelTarget.style.borderTopLeftRadius = "12px";
      this.checklistPanelTarget.style.borderTopRightRadius = "12px";
      this.checklistPanelTarget.style.borderBottomLeftRadius = "0px";
      this.checklistPanelTarget.style.borderBottomRightRadius = "0px";
    }

    // send info about the checklist via hidden form field
    if (this.hasChecklistWarningTarget) {
      this.checklistWarningTarget.value = !allChecked; // true if any unchecked
    }
  }

  // Add form validation method
  async validateForm() {
    if (!this.hasNextButtonTarget) return;

    let isFilledOut = false;
    const facilityValue = this.facilitySelectTarget.value;
    const yearValue = this.yearSelectTarget.value;
    const testValue = this.testCheckboxTarget.checked;

    if (this.hasFacilitySelectTarget && this.hasYearSelectTarget) {
      isFilledOut = facilityValue && yearValue;
    } else {
      isFilledOut = true;
    }

    if (isFilledOut) {
      const exists = await this.checkExistingCalculation(
        facilityValue,
        yearValue
      );

      if (exists && !testValue) {
        this.disableNextButton();
        this.calcExistsMessageTarget.hidden = false;
        this.checklistSectionTarget.hidden = true;
      } else {
        this.enableNextButton();
        this.calcExistsMessageTarget.hidden = true;
        this.checklistSectionTarget.hidden = false;
      }
    } else {
      this.disableNextButton();
    }
  }

  async checkExistingCalculation(facilityId, year) {
    try {
      const locale = document.documentElement.lang;
      const response = await fetch(
        `/${locale}/wage-calculations/wizard-api/calculations/exists?facility_id=${facilityId}&reporting_year=${year}&exclude=${this.calculationIdValue}`
      );
      const data = await response.json();
      return data.exists;
    } catch (error) {
      console.error("Error checking calculation existence:", error);
      return false; // fail open
    }
  }

  // Enable the next button
  enableNextButton() {
    this.nextButtonTarget.disabled = false;
  }

  // Disable the next button
  disableNextButton() {
    this.nextButtonTarget.disabled = true;
  }
}
